import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import Button from "components/Common/Button";

/**
 * @param {Object} props
 * @returns {ReactElement[]}
 * @class
 */
function GreetingEmojiList(props) {
  const { emojiList, selectedEmoji, handleEmojiSelect } = props;

  return (
    emojiList
      .keySeq()
      .toArray()
      .map(key => (
        <Button
          key={key}
          customClassName={`Greeting__left-column__message__emoji ${
            selectedEmoji === key
              ? "Greeting__left-column__message__emoji--selected"
              : ""
          }`}
          onClick={() => handleEmojiSelect(key)}
          icon={key}
          iconHeight={36}
          light
        />
      ))
  );
}

GreetingEmojiList.propTypes = {
  selectedEmoji: PropTypes.string.isRequired,
  emojiList: ImmutablePropTypes.map.isRequired,
  handleEmojiSelect: PropTypes.func.isRequired
};

export default GreetingEmojiList;
